import { List, Container } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Body1, H6 } from "../../../../components";
import { selectUsersVariables } from "../users-selectors";
import UsersPagePanel from "../users-page-panel";
import { usersPageSetModal } from "../reducers/users-page-actions";
import UsersPageModal from "../users-page-modal";
import VariablesItem from "./variables-item";

const STR = {
  titleVariable: "Variáveis",
  subtitleVariable:
    "Variáveis de usuário, para você definir, alterar e excluir, caso necessário",
  labelFabVar: "ADICIONAR",
  titleFabVar: "Clique aqui para criar uma nova variavel",
};

function VariaveisTab() {
  const [filter, setFilter] = useState("");
  const variables = useSelector(selectUsersVariables);
  const dispatch = useDispatch();
  const onAdd = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_ADD,
      })
    );
  }, [dispatch]);

  const variablesFiltered = variables?.filter(
    (variable) =>
      variable.nome.toLowerCase().includes(filter.toLowerCase()) ||
      variable.descricao.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Container maxWidth="md" disableGutters>
      <H6>{STR.titleVariable}</H6>
      <Body1 align="center">{STR.subtitleVariable}</Body1>
      <UsersPagePanel
        onAdd={onAdd}
        color="info"
        filter={filter}
        setFilter={setFilter}
        icon="Mediation"
        label={STR.labelFabVar}
        title={STR.titleFabVar}
      />
      <List disablePadding>
        {variablesFiltered?.map((variable) => (
          <VariablesItem
            key={variable.id}
            name={variable.nome}
            id={variable.id}
            description={variable.descricao}
          />
        ))}
      </List>
    </Container>
  );
}

export default VariaveisTab;
